import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import type { ReactElement } from 'react'
import type { HabitWithLog } from '../interfaces'
import { SortableHabitCard } from './SortableHabitCard'

interface DoneSectionProps {
  completedHabits: HabitWithLog[]
  isReadOnlyDate?: boolean
  isFutureDate?: boolean
  selectedDate: Date
  dayStartTime: string
  onToggle: (habit: HabitWithLog) => Promise<void>
  onEdit: (habit: HabitWithLog) => void
  onSkip: (habit: HabitWithLog) => Promise<void>
  onTogglePinned: (habit: HabitWithLog) => Promise<void>
  onSubHabitToggle: (subHabit: HabitWithLog, parentId: string) => Promise<void>
  isDesktop?: boolean
}

export function DoneSection({
  completedHabits,
  isReadOnlyDate,
  isFutureDate,
  selectedDate,
  dayStartTime,
  onToggle,
  onEdit,
  onSkip,
  onTogglePinned,
  onSubHabitToggle,
  isDesktop = false,
}: DoneSectionProps): ReactElement {
  const isReadOnly = isReadOnlyDate ?? isFutureDate ?? false
  if (completedHabits.length === 0) {
    if (isDesktop) {
      return (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-gray-200 border-dashed bg-white p-8 text-center">
          <span className="text-3xl" aria-hidden="true">
            🎯
          </span>
          <p className="mt-2 font-medium text-gray-700 text-sm">
            No habits completed yet
          </p>
          <p className="mt-1 text-gray-400 text-xs">
            Check off habits from the To Do list to see them here.
          </p>
        </div>
      )
    }
    return <div className="mt-2 mb-6" />
  }

  return (
    <div className="mt-2 mb-6">
      <div className="mb-2 flex items-center gap-2">
        <span className="text-lg">✅</span>
        <h2 className="font-semibold text-base text-gray-800">Done</h2>
        <span className="ml-auto text-gray-400 text-xs">
          {completedHabits.length}
        </span>
      </div>
      <SortableContext
        items={completedHabits.map((habit) => habit.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="mb-3 flex flex-col gap-3">
          {completedHabits.map((habit) => (
            <SortableHabitCard
              key={habit.id}
              habit={habit}
              isReadOnlyDate={isReadOnly}
              isFutureDate={isReadOnly}
              selectedDate={selectedDate}
              dayStartTime={dayStartTime}
              onToggle={onToggle}
              onEdit={onEdit}
              onSkip={onSkip}
              onTogglePinned={onTogglePinned}
              onSubHabitToggle={onSubHabitToggle}
            />
          ))}
        </div>
      </SortableContext>
    </div>
  )
}
